import React, { useState, useEffect } from 'react';
import BackIcon from '../../static/icons/back-icon.png';
import ImageMapper from 'react-image-mapper';
import axios from 'axios';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

export const FloorPlanView = (props) => {
  const { setRoomIdSelected, setRoomNameSelected, setPage, setFloorPlanScreen, listScreenClicked, dateFrom, dateTo, isDesk, isRoom, isOffice } = props;
  const [filteredArea, setFilteredArea] = useState();
  const [floorPlan, setFloorPlan] = useState({});
  const [area, setArea] = useState();
  const [availableRooms, setAvailableRooms] = useState([]);
  const employee = JSON.parse(localStorage.getItem('employee'));

  const getAvailableRooms = async () => {
    const { data } = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms/availableList`, {
      accountId: employee.accountId,
      dateFrom: new Date(dateFrom).getTime(),
      dateTo: new Date(dateTo).getTime(),
      isDesk: isDesk === undefined ? false : isDesk,
      isRoom: isRoom === undefined ? false : isRoom,
      isOffice: isOffice === undefined ? false : isOffice,
    });
    setAvailableRooms(data.rooms);
  };

  useEffect(() => {
    getAvailableRooms();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getFloorPlan = async () => {
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/floor_plans/list?accountId=${employee.accountId}`);
    const floorPlan = data.floorPlans;
    const area_map = {
      name: 'my-map',
      areas: [],
    };

    if (floorPlan.length) {
      floorPlan[0].area.forEach((ar) => {
        let color = 'red';
        const isAvailable = availableRooms.find(
          (room) => room.location === floorPlan[0].name && room.name === ar.title && (room.isBlocked === undefined || room.isBlocked === false),
        );
        if (isAvailable) {
          color = 'green';
        }
        area_map.areas.push({
          name: ar.title,
          shape: ar.shape,
          coords: ar.coords.split(',').map(function (item) {
            return parseInt(item, 10);
          }),
          preFillColor: color,
          lineWidth: 2,
        });
      });
      setArea(area_map);
      setFilteredArea(area_map);
      setTimeout(() => {
        setFloorPlan(floorPlan[0]);
      });
    }
  };

  useEffect(() => {
    getFloorPlan();
  }, [availableRooms]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleInputChange = (event) => {
    const query = event.target.value;

    setFilteredArea(() => {
      if (query) {
        const filteredData = area.areas.filter((element) => {
          return element.name.toLowerCase().includes(query.toLowerCase());
        });
        const area_map = {
          name: 'my-map',
          areas: [],
        };
        area_map.areas = filteredData;
        return area_map;
      } else {
        const area_map = {
          name: 'my-map',
          areas: [],
        };
        area_map.areas = area.areas;
        return area_map;
      }
    });
  };
  return (
    <div className="w-full grid grid-cols-1">
      <div className="static flex flex-row">
        <img
          onClick={() => {
            setFloorPlanScreen(false);
            setPage(1);
          }}
          className="w-3 h-4"
          src={BackIcon}
          alt="back"
        />
        <span
          onClick={() => {
            setFloorPlanScreen(false);
            setPage(1);
          }}
          className="text-blue-300 text-center font-semibold text-xs ml-2"
        >
          Back
        </span>
        <span className="text-center text-center font-semibold text-xs ml-8" style={{ color: '#565656' }}>
          Search results
        </span>
      </div>
      <div className="flex flex-row justify-between mt-4">
        <p className="text-center text-center font-semibold text-xs underline" style={{ color: '#51D1FA' }}>
          Floor Plan View
        </p>
        <p className="text-center font-semibold text-xs" style={{ color: '#565656' }} onClick={listScreenClicked}>
          List View
        </p>
      </div>
      <div className="relative text-gray-600 bg-gray-600 focus-within:text-gray-400 border-2 border-slate-500 rounded-md mt-2">
        <span className="absolute inset-y-0 left-0 flex items-center pl-2">
          <button type="button" className="p-1 focus:outline-none focus:shadow-outline">
            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="w-6 h-6">
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </button>
        </span>
        <input
          type="search"
          name="q"
          className="w-full py-2 text-sm text-black bg-white rounded-md pl-10 border-slate-300 focus:outline-none focus:border-blue-300"
          placeholder="Search"
          onChange={handleInputChange}
          autoComplete="off"
        />
      </div>
      <div className="mt-10 flex flex-row justify-center">
        {floorPlan.file ? (
          <ImageMapper
            src={`${REACT_APP_MY_LOBBY_BACKEND_URL}/resources/floorplans/${employee.sites[0]}/${floorPlan.file}`}
            map={filteredArea}
            width={300}
            imgWidth={floorPlan.imageDim[0]}
            // onLoad={() => this.load()}
            onClick={(area) => {
              if (area.preFillColor !== 'red') {
                const id = availableRooms.find((r) => r.name === area.name).id;
                setRoomNameSelected(area.name);
                setRoomIdSelected(id);
                setFloorPlanScreen(false);
                setPage(2);
              }
            }}
            // onMouseEnter={(area) => this.enterArea(area)}
            // onMouseLeave={(area) => this.leaveArea(area)}
            // onMouseMove={(area, _, evt) => this.moveOnArea(area, evt)}
            // onImageClick={(evt) => this.clickedOutside(evt)}
            // onImageMouseMove={(evt) => this.moveOnImage(evt)}
          />
        ) : null}
      </div>
    </div>
  );
};
